import React from "react";

const EyeIcon = ({ className, onClick }) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
    >
      <path
        d="M1.5 6.5C3.3 2.5 8.7 2.5 10.5 6.5"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6 8.5C5.80302 8.5 5.60796 8.4612 5.42597 8.38582C5.24399 8.31044 5.07863 8.19995 4.93934 8.06066C4.80005 7.92137 4.68956 7.75601 4.61418 7.57403C4.5388 7.39204 4.5 7.19698 4.5 7C4.5 6.80302 4.5388 6.60796 4.61418 6.42597C4.68956 6.24399 4.80005 6.07863 4.93934 5.93934C5.07863 5.80005 5.24399 5.68956 5.42597 5.61418C5.60796 5.5388 5.80302 5.5 6 5.5C6.39782 5.5 6.77936 5.65804 7.06066 5.93934C7.34196 6.22064 7.5 6.60218 7.5 7C7.5 7.39782 7.34196 7.77936 7.06066 8.06066C6.77936 8.34196 6.39782 8.5 6 8.5Z"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default EyeIcon;
